export default "__VITE_ASSET__qAvDo0fR__"